import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ShowcaseGetAllByAbout } from '../../services';

export const fetchShowcaseGetAllByAbout = createAsyncThunk(
    'showcaseGetAllByAbout/fetchShowcaseGetAllByAbout',
    async () => {
        const response = await ShowcaseGetAllByAbout()
        return response.result
    }
);

const showcaseGetAllByAboutSlice = createSlice({
    name: 'showcaseGetAllByAbout',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowcaseGetAllByAbout.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchShowcaseGetAllByAbout.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchShowcaseGetAllByAbout.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default showcaseGetAllByAboutSlice.reducer;
